import type { BuildingType, UnitType } from "../shared/game-types.js";

export const BUILDING_ART_PATHS: Record<BuildingType, string> = {
  gold_mine: "/assets/game-art/gold-mine.png",
  watchtower: "/assets/game-art/watchtower.png",
  wolf_den: "/assets/game-art/wolf-den.png",
  wall: "/assets/game-art/stone-wall.png",
  sumpgap: "/assets/game-art/sumpgap.png",
  acorn_catapult: "/assets/game-art/acorn-catapult.png",
  mushroom: "/assets/game-art/fly-agaric.png",
  bomb: "/assets/game-art/bomb.png",
};

const BUILDING_ART_RIGHT_FACING_SCALE_X: Record<BuildingType, 1 | -1> = {
  gold_mine: 1,
  watchtower: 1,
  wolf_den: -1,
  wall: -1,
  sumpgap: -1,
  acorn_catapult: -1,
  mushroom: 1,
  bomb: 1,
};

export function buildingArtScaleX(
  type: BuildingType,
  scale: number,
  facesRight: boolean,
): number {
  const facingScale = facesRight ? 1 : -1;
  return Math.abs(scale) * BUILDING_ART_RIGHT_FACING_SCALE_X[type] * facingScale;
}

export const UNIT_ART_PATHS: Record<UnitType, string> = {
  wolf: "/assets/game-art/wolf.png",
  rabbit: "/assets/game-art/rabbit.png",
  beaver: "/assets/game-art/beaver.png",
  hedgehog: "/assets/game-art/hedgehog.png",
};

export const UNIT_ANIMATION_PATHS: Record<UnitType, readonly string[]> = {
  wolf: [1, 2, 3, 4].map(function (frame) {
    return "/assets/game-art/wolf-run-" + frame + ".png";
  }),
  rabbit: [1, 2, 3, 4].map(function (frame) {
    return "/assets/game-art/rabbit-run-" + frame + ".png";
  }),
  beaver: ["/assets/game-art/beaver.png"],
  hedgehog: ["/assets/game-art/hedgehog.png"],
};

export const GOLD_COIN_ART_PATH = "/assets/game-art/gold-coin.png";
export const LANE_GUARD_ART_PATH = "/assets/game-art/lane-ram.png";

export const GAME_ART_PATHS = [
  ...Object.values(BUILDING_ART_PATHS),
  ...Object.values(UNIT_ART_PATHS),
  ...Object.values(UNIT_ANIMATION_PATHS).flat(),
  GOLD_COIN_ART_PATH,
  LANE_GUARD_ART_PATH,
];
